// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> stephens-farm
// Generated: 2026-10-29T18:33:38.031Z
// Counts: 0 design, 26 content, 51 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, granite counters, stainless steel appliances, smart home tech and in-unit laundry handle the daily routine. Outside, the pool, playground, BBQ grills and dog park are a short walk away, and lawn care is done for you. <a href=\"/amenities\">See every amenity</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, dog park runs, smart homes</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Weekends at Stephens Farm center on the resort-style pool, with a farmhouse-style clubhouse, shaded hammocks, a grilling station, and a playground just steps away.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a filter change twice a year, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Move-in savings on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Three- and four-bedroom townhomes in Holly Springs</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Stephens Farm, the <a href=\"/amenities\">community amenities</a> are part of a normal week: afternoons at the pool, burgers on the BBQ grills while the kids take over the playground, a walk to the dog park, and the clubhouse when you need a change of scenery.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>You can grab groceries at Holly Springs Towne Center, spend a Saturday on the trails at Sugg Farm, and take NC 540 to Apex, Cary, RTP or a growing biotech campus nearby. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Settled into everyday Holly Springs</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Dogs get their own on-site dog park, and select homes come with fenced backyards. Longer walks are close by at Bass Lake Park and the trails at Sugg Farm. See the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>See a Stephens Farm townhome on your own schedule with a <a href=\"/schedule-a-tour\">self-guided tour</a>, or meet our leasing team for a walk through the homes, pool and grounds.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside the three- and four-bedroom townhomes at Stephens Farm from anywhere: pick a tour from the list to look around at your own pace, then compare layouts on our <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">book a self-guided tour</a> in Holly Springs.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-97b7-75c1-adf5-a8ca91d434cf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lawn mower parked on freshly cut grass"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-a111-74ef-a90c-8297024461c0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Person pointing to a smart thermostat on a wall"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e01-7188-9b80-c0a66a264baa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Little girl sitting on a float in a swimming pool"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e06-715e-8257-e4ec02092f2b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Young boy going down a playground slide"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e4e-71ad-ac37-699851940d55.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Small brown and white dog running with a toy in its mouth"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8f7b-7221-a04f-5376e4a5fbcc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple sitting on a couch looking at a laptop together"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-ecf0-7709-b96e-81f4ded0065e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stephens Farm outdoor pool with lounge chairs and a shaded pavilion"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15acd-fa43-710d-91ff-46b741f9dbd3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Stephens Farm townhomes surrounding the community pool"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15ace-18b3-7088-a410-f9472bbc39a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island, stainless steel appliances, and granite countertops."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-ecf0-7709-b96e-81f4ded0065e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool with lounge chairs and a shaded pavilion"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e022-72cd-b368-80e02fb93af5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Farmhouse-style clubhouse with a front porch and barn door"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e0c0-73e9-bc61-3ee719b776c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Hammocks and lounge chairs under a pergola beside the pool"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Hammock Lounge"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-f0c9-755b-bcc7-132511e50b10.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor grilling station near the community pool"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "BBQ Grills"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-d4b0-776a-8270-a63226f7bdda.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the community pool and playground"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15acd-e2cf-763b-aff5-f91bfacd3f05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with rows of townhouses and surrounding greenery."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Space"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-829b-7322-b616-64cfa2051cc8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stephens Farm townhomes with brick and siding exteriors and two-car garages"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e565-7497-80a9-ccf5c9348455.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Primary bedroom with a king bed and large windows"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-d4b0-776a-8270-a63226f7bdda.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the Stephens Farm pool, playground and surrounding townhomes"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-b1de-737d-ad30-68e04a4674fe.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living area flowing into a kitchen with island and bar seating"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-ecf0-7709-b96e-81f4ded0065e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community pool with lounge chairs and a shaded pavilion"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15ace-18b3-7088-a410-f9472bbc39a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with island, granite countertops and stainless steel appliances"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e022-72cd-b368-80e02fb93af5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Farmhouse-style clubhouse with a front porch and barn door"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e0c0-73e9-bc61-3ee719b776c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Hammocks and lounge chairs under a pergola beside the pool"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-f0c9-755b-bcc7-132511e50b10.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community grilling station near the swimming pool"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15ace-0f1d-77ca-ae39-64a211bca027.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living and dining area with large windows, sofa and dining table"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside afternoons"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "When the Holly Springs heat sets in, the community pool is a short walk from your townhome."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Grill and play"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Shared BBQ grills make a cookout with the neighbors easy, and the playground and dog park keep kids and pups busy nearby."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse time"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The community clubhouse gives you somewhere to open your laptop or meet up when you want to get out of the house."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-36c4-72ae-8bf5-abfcf6c15f55.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lake view at Bass Lake Park in Holly Springs"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Bass Lake Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e4e-71ad-ac37-699851940d55.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "a small brown and white dog running with a toy in its mouth"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "On-site dog park"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec30-0836-7549-8c55-0df879268a8c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Brick and siding townhomes with attached garages at Stephens Farm"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome Exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-d4b0-776a-8270-a63226f7bdda.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the community pool and playground at Stephens Farm"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool & Playground"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec30-2c73-7287-bacb-39b0910ba1f0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living and dining area with a kitchen featuring stainless steel appliances"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living Area"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-e022-72cd-b368-80e02fb93af5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Farmhouse-style clubhouse with a front porch and barn door"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15ace-18b3-7088-a410-f9472bbc39a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island, stainless steel appliances, and granite countertops."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-f0c9-755b-bcc7-132511e50b10.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community grilling station beside the pool"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Grilling Station"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Chelsea was seriously the best part"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Responsive maintenance"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "the maintenance staff actually fixes things"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Smooth move-in"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "got us into our home quickly"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Quality homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "new, modern, and in great condition"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Convenient location"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "a beautiful place and very convenient"
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Great neighbors"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "a great quiet community"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167639/01a15acd-e318-7118-b8c0-ce9a2b913486.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Front of Stephens Farm townhomes with brick and siding, attached garages and front doors"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
